@if (unsignedDocument()) {
  <oui-document-viewer
    class="slide-panel-viewer"
    [documentUrl]="fileUrls()"
    [showControls]="true">
    <div
      class="document-controls"
      oui-document-controls>
      <div>
        <div class="document-name-container">
          <div class="document-name">
            <div class="headline-6">Profil Investisseur</div>
          </div>

          <oui-button
            type="icon"
            color="secondary"
            (click)="closeSlidePanel()">
            <oui-icon>close</oui-icon>
          </oui-button>
        </div>

        <div class="flex-vertical gap-32 top-margin-8">
          @if (signedDocument()) {
            @if (signedDocument()?.updatedDate) {
              <div class="document-date">
                Dernière mise à jour le {{ $safeNavigationMigration(signedDocument()?.updatedDate) | date: 'dd/MM/yyyy à HH:mm' }}
              </div>
            }
            <oui-button (click)="downloadDocument(signedDocument())"> Télécharger le document </oui-button>
          } @else {
            @if (unsignedDocument()?.updatedDate) {
              <div class="document-date">
                Dernière mise à jour le {{ $safeNavigationMigration(unsignedDocument()?.updatedDate) | date: 'dd/MM/yyyy à HH:mm' }}
              </div>
            }
            <oui-button
              type="outlined"
              (click)="downloadDocument(unsignedDocument())">
              Télécharger le document
            </oui-button>

            @if (showSendToSignature()) {
              <div
                [ouiTooltip]="signatureTooltip()"
                class="width-fill-available">
                <oui-button
                  class="width-fill-available"
                  iconPrefix="signature"
                  (click)="sendToSignature()"
                  [disabled]="signatureDisabled()">
                  Envoyer en signature
                </oui-button>
              </div>
            }
          }
        </div>
      </div>
    </div>
  </oui-document-viewer>
} @else {
  <div class="loading-container">
    @if (isFetchingDoc()) {
      <oui-loading></oui-loading>
    } @else {
      <oui-etat-vide
        [title]="'Aucun document'"
        icon="unknown_document"></oui-etat-vide>
    }
  </div>
}
